import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { connect } from 'react-redux';
import { withCookies } from 'react-cookie';
import {
  selectAccessToken,
  selectIsSignedInWithEmail,
  selectUserInfo,
} from '@client/redux/user/userReducer';
import styleHelper from '@client/shared/styles/styleHelper.scss';
import FormWrapper from '@client/components/formComponents/formWrapper/FormWrapper';
import FormSectionContainer from '@client/containers/formSectionContainer/FormSectionContainer';
import InputGroup from '@client/components/formComponents/inputGroup/InputGroup';
import { valueOrEmptyStr } from '@client/shared/utils/utils/utils';
import {
  min,
  oneOf,
  required,
  useRef,
  validateObject,
  validateString,
} from '@client/shared/utils/validation/validation';
import { putUserPassword } from '@client/connectivity/api.user';
import { getIn } from '@client/shared/utils/immutableUtils/immutableUtils';
import { handleLogout } from '@client/redux/user';
import { useAuth0 } from '@client/helperComponents/react-auth0-spa';
import { NotificationContext } from '@client/components/notificationProvider/NotificationProvider';
import styles from './changePasswordRoute.scss';

class FormChangePassword extends PureComponent {
  static contextType = NotificationContext;
  render() {
    const { className, formProps, translations } = this.props;

    const formValues = formProps.values;
    const formErrors = formProps.errors;
    return (
      <form
        onSubmit={formProps.handleSubmit}
        className={`${styles.formChangePassword}${
          className ? ` ${className}` : ''
        }`}
      >
        <FormSectionContainer
          className={styles.formSectionContainerProp}
          title={'Ändra lösenord'}
        >
          <div className={styles.subTitle}>
            Vänligen fyll i ett nytt lösenord för att uppdatera det.
          </div>
          <div className={styleHelper.flexCol}>
            <div className={styles.passwordInput}>
              <InputGroup
                type="password"
                labelText={'Nytt lösenord*'}
                name={'newPassword'}
                value={valueOrEmptyStr(formValues.newPassword)}
                onChange={formProps.handleChange}
                onBlur={formProps.handleBlur}
                errorLabel={formErrors.newPassword}
              />
            </div>
            <div className={styles.passwordInput}>
              <InputGroup
                type="password"
                labelText={'Bekräfta nytt lösenord*'}
                name={'repeatPassword'}
                value={valueOrEmptyStr(formValues.repeatPassword)}
                onChange={formProps.handleChange}
                onBlur={formProps.handleBlur}
                errorLabel={formErrors.repeatPassword}
              />
            </div>
          </div>
          <div className={`${styleHelper.flexRow} ${styles.buttonContainer}`}>
            <button
              type="submit"
              className={`${styleHelper.btnPrimaryMd} ${styles.button}`}
            >
              Uppdatera
            </button>
          </div>
        </FormSectionContainer>
      </form>
    );
  }
}

function FormContainer({ accessToken, userInfo, dispatch, cookies }) {
  const auth = useAuth0();

  const renderForm = (formProps) => {
    return <FormChangePassword formProps={formProps} />;
  };

  const handleSubmit = (values, { setErrors }) => {
    putUserPassword(values, getIn(userInfo, 'sub'), accessToken)
      .then(() => {
        dispatch(handleLogout(cookies));
        auth.logout();
      })
      .catch((error) => {
        if (error) {
          if (error.status) {
            this.context.displayNotification(
              'ERROR',
              error.title || error.detail
            );
          }
        }
      });
  };

  return (
    <FormWrapper
      onSubmit={handleSubmit}
      component={renderForm}
      validateOnBlur={true}
      initialValues={{
        newPassword: '',
        repeatPassword: '',
      }}
      validationSchema={validateObject({
        newPassword: min(8, 'minst 8 tecken')
          .matches(/[a-z]/, 'minst 1 liten bokstav')
          .matches(/[A-Z]/, 'minst 1 stor bokstav')
          .matches(
            /[a-zA-Z]+[^a-zA-Z\s]+/,
            'minst 1 nummer eller specialtecken (@,!,#, etc).'
          ),
        repeatPassword: required(
          oneOf(
            validateString(),
            [useRef('newPassword'), null],
            'Lösenorden måste vara lika'
          ),
          'Du måste bekräfta ditt lösenord'
        ),
      })}
    />
  );
}

class ChangePasswordRoute extends PureComponent {
  render() {
    const {
      signedInWithEmail,
      accessToken,
      userInfo,
      dispatch,
      cookies,
    } = this.props;

    return (
      <div className={styles.changePasswordRoute}>
        {signedInWithEmail ? (
          <>
            <h3
              className={`${styleHelper.titleMdPrimary} ${styleHelper._title} ${styles.title}`}
            >
              Ändra lösenord
            </h3>
            <FormContainer
              userInfo={userInfo}
              accessToken={accessToken}
              cookies={cookies}
              dispatch={dispatch}
            />
          </>
        ) : (
          <h3
            className={`${styleHelper.titleMdPrimary} ${styleHelper._title} ${styles.title}`}
          >
            Du kan
          </h3>
        )}
      </div>
    );
  }
}

ChangePasswordRoute.propTypes = {
  dispatch: PropTypes.func,
  accessToken: PropTypes.string,
  signedInWithEmail: PropTypes.bool,
  userInfo: ImmutablePropTypes.map,
};

function mapStateToProps(state) {
  return {
    userInfo: selectUserInfo(state),
    accessToken: selectAccessToken(state),
    signedInWithEmail: selectIsSignedInWithEmail(state),
  };
}

export default withCookies(connect(mapStateToProps)(ChangePasswordRoute));
